import { AgentMixer } from '@linktivity/sagano';

import config from '../config';

const agentmixer = new AgentMixer.AgentMixerApi(config);

export default agentmixer;
